import type { ChatResolveEntityOption } from '../models/admin/AdminChatResolveDraft';

const CONTACT_INVESTOR_TYPES = new Set(['CONTACT', 'INVESTOR']);

export function filterContactAndInvestorOptions(
  options: ChatResolveEntityOption[],
): ChatResolveEntityOption[] {
  return options.filter((option) => CONTACT_INVESTOR_TYPES.has(option.modelType));
}

/** Puts the AI-suggested entity first, then other investments, then contact. */
export function orderAttachToOptions(
  options: ChatResolveEntityOption[],
  selected?: { modelType: string; modelExternalId: string } | null,
): ChatResolveEntityOption[] {
  const filtered = filterContactAndInvestorOptions(options);
  if (!filtered.length) return filtered;

  const selectedKey =
    selected?.modelType && selected?.modelExternalId
      ? `${selected.modelType}:${selected.modelExternalId}`
      : null;

  const rank = (option: ChatResolveEntityOption): number => {
    const key = `${option.modelType}:${option.modelExternalId}`;
    if (selectedKey && key === selectedKey) return 0;
    if (option.modelType === 'INVESTOR') return 1;
    if (option.modelType === 'CONTACT') return 2;
    return 3;
  };

  return [...filtered].sort(
    (left, right) => rank(left) - rank(right) || left.label.localeCompare(right.label),
  );
}
